import request from '../utils/request';
// 初始参数 /app/config
export function getconfig(data) {
	return request({
		url: '/app/config',
		method: 'post',
		data,
	});
}

// /app/agreement 用户协议
export function agreement(data1) {
	const data = Object.assign(data1, { sdk_code: 2 });
	console.log(data);
	return request({
		url: '/app/agreement',
		method: 'post',
		data,
	});
}
// /app/query
export function appQuery(data) {
	return request({
		url: '/app/query',
		method: 'post',
		data,
	});
}
// //app/agreement
export function delagreement(data) {
	return request({
		url: '/app/agreement',
		method: 'post',
		data,
	});
}
// /user/query_del_submit_enable
export function query_del_submit_enable(data) {
	return request({
		url: '/user/query_del_submit_enable',
		method: 'post',
		data,
	});
}
// /user/get_game_info
export function get_game_info(data) {
	return request({
		url: '/user/get_game_info',
		method: 'post',
		data,
	});
}

// /user/del_user_submit 注销账户申请
export function del_user_submit(data) {
	return request({
		url: '/user/del_user_submit',
		method: 'post',
		data,
	});
}
// agreement_section 网页协议类型获取
export function agreement_section(data) {
	return request({
		url: '/app/agreement_section',
		method: 'post',
		data,
	});
}
// /app/agreement_section_id
export function agreement_section_id(data) {
	return request({
		url: '/app/agreement_section_id',
		method: 'post',
		data,
	});
}
